import { Controller } from "@hotwired/stimulus"
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ["container"]

  accept() {
    const isSecure = location.protocol === 'https:'
    Cookies.set('cookie_eu_consented', true, {
      path: '/',
      expires: 365,
      secure: isSecure
    })

    this.element.remove()

    document.dispatchEvent(new CustomEvent('cookies-eu-acknowledged'))

    if ('Turbo' in window) {
      window.Turbo.clearCache()
    }
  }

  acceptMobile() {
    const isSecure = location.protocol === 'https:'
    Cookies.set('ask_mobile', true, {
      path: '/',
      expires: 365,
      secure: isSecure
    })

    this.element.remove()
  }
}
